import { render, staticRenderFns } from "./AtomCheck.vue?vue&type=template&id=5f85e6e2&"
import script from "./AtomCheck.vue?vue&type=script&lang=js&"
export * from "./AtomCheck.vue?vue&type=script&lang=js&"
import style0 from "./AtomCheck.vue?vue&type=style&index=0&id=5f85e6e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
